import utility from './utility'

const misc = {
    init: function () {
        //Temp older ie polyfill for forEach
        if (typeof NodeList.prototype.forEach !== 'function') {
            NodeList.prototype.forEach = Array.prototype.forEach;
        }

        this.mainAdjustPos.init();
        this.toolTips();
        this.popUps();
        this.hashScroll();
        this.validatePassword();
        this.togglePassword();
        this.toggleClass();
        this.toggleSyndicateShares();        
        this.lotteryFilter();
        window.addEventListener('load',
            () => {
                this.faqFilter();
                this.faqScrollMenu();
                this.charityList();
                this.clickLottoSystems();
            });

        const navItems = [...document.querySelectorAll('#header-top-nav > li')];
        navItems.map(item => {
            item.addEventListener('click',
                e => {
                    const desktopItem = item.querySelector('.top-nav--desktop-item');
                    if (!desktopItem || utility.findAncestor(e.target, 'top-nav--desktop-item') !== null)
                        return;
                    const activeItem = navItems.find(navItem => navItem.classList.contains('nav-active'));
                    if (activeItem) {
                        activeItem.classList.remove('nav-active');
                    }
                    item.classList.add('nav-active');
                });
        });

        window.addEventListener('click', e => {
            if (!utility.findAncestor(e.target, 'nav-active') && !e.target.classList.contains('nav-active')) {
                const activeNavItem = document.querySelector('#header-top-nav > li.nav-active');
                if (activeNavItem) {
                    activeNavItem.classList.remove('nav-active');
                }
            }

            //Menu sidebar click outside to hide
            if (e.target.id == 'nav-expand') {
                return
            } else {
                if (document.querySelector(`body.scroll-hidden`) && document.querySelector(`#header-nav.active`)) {
                    document.querySelector(`#nav-expand.active`).click()
                }
            }
        });

        // Add Bookmark alert on footer
        //const addfav = document.querySelector(".addfav");
        //if (addfav) {
        //    addfav.onclick = (e) => {
        //        e.preventDefault();
        //        alert('Press ' + (navigator.userAgent.toLowerCase().indexOf('mac') != - 1 ? 'Command/Cmd' : 'CTRL') + ' + D on your keyboard to bookmark this page.');
        //    }
        //}
    },

    logoShrink: () => {
        window.addEventListener('scroll', () => {
            const windowOffset = window.scrollY;
            const scrollDisabled = document.body.classList.contains('scroll-hidden');

            if (scrollDisabled) {
                return;
            }

            if (windowOffset > 0) {
                utility.addClass(document.body, 'nav-small');
            }
            else {
                utility.removeClass(document.body, 'nav-small');
            }
        });
    },

    mainAdjustPos: {
        init: function () {
            const _this = this;
            _this.adjustPos();
            window.addEventListener('scroll',
                () => {
                    setTimeout(function () {
                        _this.adjustPos();
                    },
                        300);
                });
        },

        adjustPos: () => {
            const userEdit = document.getElementById("user-edit");
            if (userEdit) {
                // override style for google address lookup to display correctly over modals which has different margins
                let sheet = document.getElementById("__google_address_style_override");
                if (!sheet) {
                    sheet = document.createElement('style');
                    document.body.appendChild(sheet);
                }
                sheet.id = "__google_address_style_override";
                sheet.innerHTML = '.pac-container { z-index: 10000; }';
            }
        }
    },

    toolTips: () => {
        [...document.querySelectorAll('.tooltip-action')].map(toolTip => {
            const tooltipContent = document.querySelector(`#${toolTip.dataset.tooltip}`);

            toolTip.onclick = () => {
                tooltipContent.classList.toggle('active');
            }

            document.addEventListener('click',
                function (event) {
                    const isClickInside = tooltipContent.contains(event.target) || utility.findAncestor(toolTip, 'input-tooltip').contains(event.target);
                    if (!isClickInside && tooltipContent.classList.contains('active')) {
                        utility.removeClass(tooltipContent, 'active');
                    }
                });
        });
    },

    popUps: () => {
        const bodyHidden = document.querySelector('body.scroll-hidden');
        if (bodyHidden) {
            utility.htmlScroll('hidden');
        }

        [...document.querySelectorAll('.popup-close')].map(popUpClose => {
            popUpClose.onclick = () => {
                [...document.querySelectorAll('.popup')].map(popup => {
                    popup.classList.remove('active');
                    utility.htmlScroll('initial');
                });
            }
        });
    },

    hashScroll: () => {
        [...document.querySelectorAll('a[href*="#"]')].forEach(hashClick => {
            hashClick.addEventListener("click",
                function (e) {
                    let currentPagePath = window.location.pathname;
                    let targetPagePath = this.pathname;
                    if (currentPagePath !== targetPagePath) {
                        return;
                    }
                    let href = this.getAttribute("href");
                    href = href.substring(href.indexOf("#") + 1);
                    const target = document.getElementById(href);

                    if (!target) {
                        return;
                    }

                    e.preventDefault();

                    if (e.target.classList.contains('expand-no-scroll')) {
                        return;
                    }
                    else {
                        const header = document.getElementById("header");
                        target.style.paddingTop = `${header.offsetHeight + 25}px`;
                        target.style.marginTop = `-${header.offsetHeight + 25}px`;

                        window.scrollBy({
                            'behavior': "smooth",
                            'left': 0,
                            'top': target.getBoundingClientRect().top
                        });
                    }
                });
        });
    },

    validatePassword: () => {
        [...document.querySelectorAll(".password-strength")].map(passwordContainer => {
            const passwordInput = passwordContainer.querySelector(".password-strength--password");
            const passwordValidation = passwordContainer.querySelector(".password-strength--validation");

            passwordInput.addEventListener("input",
                e => {
                    const value = e.target.value;
                    const valueLength = value.length >= 8;
                    const valueCap = value.match(/[a-z]/) && value.match(/[A-Z]/);
                    const valueNumber = value.match(/\d+/);

                    const validationArr = [
                        {
                            error: "Use at least 8 characters",
                            validation: valueLength
                        },
                        {
                            error: "Use Upper and lower case characters, E.g. 'A','a'",
                            validation: valueCap
                        },
                        {
                            error: "Use 1 or more numbers",
                            validation: valueNumber
                        }
                    ];

                    const validationMessage = validationArr.map(({ validation, error }) => {
                        return `<p>${!validation
                            ? '<svg xmlns="http://www.w3.org/2000/svg" fill="#d0021b" width="24" height="24" viewBox="0 0 352 512"><path d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"/></svg>'
                            : '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="green" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon-check-circle"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>'
                            } ${error}</p>`;
                    }).join("");

                    if (!validationArr.find(validation => !validation)) {
                        passwordValidation.innerHTML = validationMessage;
                    }
                });
        });
    },

    togglePassword: () => {
        [...document.querySelectorAll('.toggle-password')].map(toggle => {
            toggle.onclick = () => {
                const passwordInput = toggle.parentNode.querySelector('input');
                toggle.classList.toggle('active');
                passwordInput.type = passwordInput.type === 'password' ? 'text' : 'password';
            }
        });
    },

    toggleClass: () => {
        [...document.querySelectorAll('.trigger')].map(toggle => {
            toggle.onclick = (event) => {
                event.preventDefault();
                var content = document.querySelector(event.target.hash);
                if (!content) return;

                // If the content is already expanded, collapse it and quit
                if (content.classList.contains("active")) {
                    content.classList.remove("active");
                    return;
                }

                // Get all open accordion content, loop through it, and close it
                var accordions = document.querySelectorAll(".white-box--shadow.active");
                for (var i = 0; i < accordions.length; i++) {
                    accordions[i].classList.remove("active");
                }

                // Toggle our content
                content.classList.toggle("active");
            }
        });
    },

    toggleSyndicateShares: () => {
        [...document.querySelectorAll('.add,.minus')].map(toggle => {
            toggle.onclick = (event) => {
                const changeShares = event.target.className;
                const sharesInput = utility.findAncestor(event.currentTarget, "syndicates-form").querySelector("input[name=shares]");
                const maxShares = sharesInput.max;
                const minShares = sharesInput.min;
                let sharesInputVal = parseInt(sharesInput.value);
                const sharesPrice = toggle.dataset.shareprice;
                let totalCost = utility.findAncestor(event.currentTarget, "syndicates-form").querySelector(".total-syndicate-cost");
                //let shareOf = utility.findAncestor(event.currentTarget, "syndicates-form").querySelector(".shareOf");
                let shareAmount = utility.findAncestor(event.currentTarget, "syndicates-form").querySelector(".shareAmount");

                if (changeShares === 'add' && sharesInputVal < maxShares) {
                    sharesInputVal++;
                }
                else if (changeShares === 'minus' && sharesInputVal > minShares) {
                    sharesInputVal--;
                }
                sharesInput.value = sharesInputVal;
                //shareOf.innerHTML = sharesInputVal;
                totalCost.innerHTML = (sharesPrice * sharesInputVal).toFixed(2);

                //change share/shares text on add sub box
                shareAmount.innerHTML = sharesInputVal > 1 ? "Shares" : "Share";
                event.preventDefault();
            }
        });
    },

    charityList: () => {
        let charitylist = document.querySelector("#charity-ul-list");
        let filteredApiCall = `https://blog.lotteryoffice.com.au/wp-json/wp/v2/posts?_fields=title,slug,acf&per_page=100&categories=7`;
        if (charitylist) {
            fetch(filteredApiCall, { method: 'GET' })
                .then(response => response.json())
                .then(response => {
                    const featuredCharities = response.filter((charity) => charity.acf.feature_on_charity_page == true);
                    charitylist.innerHTML = featuredCharities.map((charity, index) => {
                        return `
                    <li class="d-flex ${index >= 6 ? 'hiddenStyle' : ''}">
                        <a href="https://www.lotteryoffice.com.au/magazine/${charity.slug}/" class="d-flex">
                            <img src="${charity.acf.charity_logo}" alt="${charity.title.rendered}" class="m-auto" />
                            <div class="d-flex flex-column text-left charity-box">
                                <h2 class="blue m-0">${charity.acf.charity_amount}</h2>
                                <p class="m-0 charity-desc">${charity.acf.charity_desc}</p>
                                <p class="m-0 italics">${charity.acf.charity_date}</p>
                            </div>
                        </a>
                    </li>`
                    }).join('');

                }).catch((error) => {
                    charitylist.style.display = 'none';
                });


            let items = Array.from(charitylist.querySelectorAll("#charity-ul-list li"));
            let loadMore = document.getElementById("loadMore");
            let maxItems = 6;
            let loadItems = 6;
            let hiddenClass = "hiddenStyle";

            items.map((item, index) => {
                if (index > maxItems - 1) {
                    item.classList.add(hiddenClass);
                }
            });

            loadMore.onclick = () => {
                let hiddenItems = document.querySelectorAll("." + hiddenClass);
                [...hiddenItems].map((item, index) => {
                    if (index < loadItems) {
                        item.classList.remove(hiddenClass);
                    }
                });

                if (hiddenItems.length < 6) {
                    loadMore.style.display = "none";
                }
            };
        }
    },

    lotteryFilter: () => {
        [...document.querySelectorAll('.lottery-filter')].map(lottofilter => {
            lottofilter.onclick = (event) => {
                lottofilter.classList.add('active');
                lottofilter.nextElementSibling ? lottofilter.nextElementSibling.classList.remove('active') : "";
                lottofilter.previousElementSibling ? lottofilter.previousElementSibling.classList.remove('active') : "";
                [...document.querySelectorAll('.lottery-card')].map(lott => {
                    lott.classList.remove('fade-out');
                });
                const filterTab = lottofilter.id;
                if (filterTab) {
                    const moreLottories = document.querySelector('.more-lotteries');
                    if (moreLottories) {
                        moreLottories.style.display = 'none';
                    }
                    if (filterTab === 'usa-filter') {
                        [...document.querySelectorAll('.euro-lottery')].map(lott => {
                            lott.classList.add('fade-out');
                        });
                        [...document.querySelectorAll('.us-lottery')].map(lott => {
                            lott.classList.remove('extra-lottery');
                        });
                    }
                    else {
                        [...document.querySelectorAll('.us-lottery')].map(lott => {
                            lott.classList.add('fade-out');
                        });
                        [...document.querySelectorAll('.euro-lottery')].map(lott => {
                            lott.classList.remove('extra-lottery');
                        });
                    }
                }

                //trick to keep tabs and filter - always show first tab box
                [...document.querySelectorAll('.tab-content')].map(allfilter => {
                    allfilter.classList.remove('active');
                });
                document.getElementById('lottery-tab--all-lotteries').classList.add('active');//keep all lotteries tab content active
                document.getElementById('all-filter').classList.remove('active');//hide all lotteries tab nav active
                event.preventDefault();
            }
        });
    },

    faqFilter: () => {
        let menuNavs = [...document.querySelectorAll(".faq-page #faq-nav li a")];
        if (window.location.hash) {
            let hashId = window.location.hash.substring(1);
            menuNavs.map(list => {
                utility.removeClass(list, 'active')
                if (hashId && list.classList.contains(hashId)) {
                    utility.addClass(list, 'active')
                }
            });

            if (hashId == 'how-do-lotto-systems-work') {
                const urlNavClick = document.getElementById('how-do-lotto-systems-work').firstElementChild;
                urlNavClick.click();
            }

        }
        else {
            let firstQuestion = document.querySelector(".faq-page a.firstQuestion");
            if (firstQuestion) {
                firstQuestion.click();
            }
        }
        menuNavs.map(list => {
            list.onclick = (e) => {
                utility.findAncestor(e.currentTarget, "faq-nav").querySelectorAll(".active")
                    .forEach(e => e.classList.remove("active"));
                utility.addClass(e.target, 'active')
            };
        });
        let mobilefaqnav = document.querySelector(".faq-nav-mobile");
        if (mobilefaqnav) {
            mobilefaqnav.onchange = (e) => document.getElementById(e.currentTarget.value).scrollIntoView({
                block: "start",
                behavior: "smooth"});
        }
        //contactNavs.map(list => {
        //    list.onclick = (e) => {
        //        utility.findAncestor(e.currentTarget, "faq-nav").querySelectorAll(".active").forEach(e => e.classList.remove("active"));
        //        utility.addClass(e.target, 'active')
        //    };
        //});
 
       
     },

    faqScrollMenu: () => {
        const faqSections = document.querySelectorAll('.faq-page .main > .container > div');
        const menuNavs = [...document.querySelectorAll(".faq-page #faq-nav li a")];

        const observerOptions = {
            root: null,
            rootMargin: '-20px',
            threshold: 0.2,
        };

        function observerCallback(entries, observer) {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    const navItem = document.querySelector(`ul#faq-nav li a[href="#${entry.target.id}"]`);
                    navItem.classList.add('active');
                    Object.values(menuNavs).forEach((item) => {
                        if (item != navItem) {
                            item.classList.remove('active');
                        }
                    });
                }
            });
        }

        const observer = new IntersectionObserver(observerCallback, observerOptions);
        faqSections.forEach((sec) => observer.observe(sec));
    },

    clickLottoSystems: () => {
        //to cater for click directly from lotto systems page
        const pageurl = new window.URLSearchParams(window.location.search).get('showtab');
        if (pageurl && pageurl == 'lotto-systems') {
            const lottosystab = document.querySelector("span[data-tab='play-now--systems']").click();
            if (lottosystab) {
                lottosystab.click();
            }
        }
    }

}

export default misc


// WEBPACK FOOTER //
// ./assets/src/js/classes/misc.js